import store from '@/store'

const isAuthenticatedGuard = async ( to, from, next ) => {
    const { success, model } = await store.dispatch('auth/checkAuthentication')

    if ( success ) {
        const menuUser = model.rol.menu.split(',')
        
        if (menuUser.indexOf(to.name) > -1) {
            next()
        } else {
            next({ name: 'NotFound' })
        }

    } 
    else {
        next({ name: 'login'})
    }
    

    // else if (from.path != '/') {
    //     next({ name: 'login'})
    // }
    // else {
    //     next()
    // }
}

export default isAuthenticatedGuard